import { Link } from "react-router-dom";
import { Wallet } from "lucide-react";

export const EmptyAccounts = () => (
  <div className="panel p-10 text-center rise" data-testid="empty-accounts">
    <Wallet className="h-8 w-8 mx-auto text-slate-600" />
    <p className="mt-3 text-slate-300">Add your first broker account to start journaling.</p>
    <Link to="/accounts" data-testid="go-add-account-link" className="inline-block mt-4 px-4 py-2 rounded-md bg-emerald-600 hover:bg-emerald-500 text-white text-sm transition-colors">Add account</Link>
  </div>
);
